import { Button, Modal } from '@bb/ui';
import type { DependentView } from '../../api/client.ts';
import { DependentItem } from './WhereUsedPanel.tsx';

/** The answer to an archive refused with `object_in_use` (BB-47): what still uses the object, with links. */
export function ObjectInUseDialog({ open, onOpenChange, what, dependents }: { open: boolean; onOpenChange: (open: boolean) => void; what: string; dependents: DependentView[] }) {
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title={`${what} is in use`}
      description="Change or stop these first, then archive again."
      footer={
        <Button variant="ghost" onClick={() => onOpenChange(false)}>
          Close
        </Button>
      }
    >
      <ul aria-label="Dependents">
        {dependents.map((d) => (
          <DependentItem key={`${d.objectType}:${d.objectId}`} d={d} />
        ))}
      </ul>
    </Modal>
  );
}
